"use client"

import { useEffect } from "react"

/**
 * The membership-first site's black buttons answer a hover with a soft,
 * lighter wave that spreads from where the cursor came in (Eugene, 01.10:
 * a darker black would not show). The wave is a `::before` in globals.css;
 * this only tells it where to start, as `--ripple-x` and
 * `--ripple-y` on the button. Must match the selector there. Renders null,
 * mounted by the locale layout on the flag site only.
 */
const RIPPLE_SELECTOR =
  ":is(a, button):is(.bg-neutral-950.rounded-full, :is(header, [role='dialog']) .bg-aubergine-800, [data-quiz] .bg-aubergine-800.rounded-full, [data-tools] .bg-aubergine-800.rounded-full)"

export function ButtonRipple() {
  useEffect(() => {
    const onOver = (e: PointerEvent) => {
      if (e.pointerType !== "mouse") return
      const button = (e.target as Element | null)?.closest?.(RIPPLE_SELECTOR)
      if (!(button instanceof HTMLElement)) return
      // Only on entry: moves inside the button keep the wave's origin.
      if (e.relatedTarget instanceof Node && button.contains(e.relatedTarget))
        return
      const box = button.getBoundingClientRect()
      button.style.setProperty("--ripple-x", `${e.clientX - box.left}px`)
      button.style.setProperty("--ripple-y", `${e.clientY - box.top}px`)
    }
    document.addEventListener("pointerover", onOver, { passive: true })
    return () => document.removeEventListener("pointerover", onOver)
  }, [])
  return null
}
